import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useEffect, useRef } from "react";
import { WITH_TRAVELCARD } from "./PaymentMethod";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  Heading,
} from "@ogt/ui";

export default function PaymentWithTravelcard() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 40;
  // Reset specific fields if the selected compensation is not WITH_TRAVELCARD
  useEffect(() => {
    if (formData.paymentmethod === WITH_TRAVELCARD) {
      setFormData((prev) => ({
        ...prev,
        ticketnumber: "",
        phonenumberapp: "",
      }));
    }
  }, [formData.compensation, setFormData]);

  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values, { setSubmitting, setErrors }) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/ersattning-for");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          cardnumber: Yup.string()
            .required("Vänligen fyll i ditt kortnummer")
            .min(12, "Kortnumret måste innehålla minst 12 siffror")
            .matches(/^\d+$/, "Kortnumret får bara innehålla siffror"),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading progress={progress} headingRef={h2Ref} focusable id="">
                  Jag hade biljetten på ett reskort
                </Heading>

                <p>
                  För att gå vidare behöver vi ditt reskortsnummer. Det hittar
                  du på kortets baksida.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="cardnumber"
                  label={
                    <>
                      Mitt reskortsnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="text"
                  numbersOnly
                  autocomplete={"off"}
                  moreinfo="12 Siffror "
                  maxLength={12}
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
